import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {BankPaymentRecordModel} from "../models/bankPaymentRecordModel";

@Injectable({
  providedIn: 'root'
})
export class BankPaymentRecordsService {

  private endpointUrl = `${environment.apiUrl}/bank-payment-records`;

  constructor(private http: HttpClient) {
  }

  public getAll(isIndividualActive: boolean): Observable<Array<BankPaymentRecordModel>> {
    const params = new HttpParams().set('isIndividualActive', isIndividualActive.toString());
    return this.http.get<Array<BankPaymentRecordModel>>(`${this.endpointUrl}`, { params });
  }

}
